import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId =
      new URLSearchParams(location.hash.slice(1)).get("session_id") ||
      new URLSearchParams(location.search).get("session_id");
    const run = async () => {
      try {
        const user = await api(`/auth/session?session_id=${encodeURIComponent(sessionId)}`);
        const { business } = await api("/business/me");
        navigate(business ? "/app" : "/onboarding", { state: { user }, replace: true });
      } catch (e) {
        console.error("Google sign-in session exchange failed:", e.message);
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [location.hash, location.search, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F7F7F5]">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-guinep-line border-t-guinep-deep" />
    </div>
  );
};

export default AuthCallback;
